import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
 import {HomeModule} from './home/home.module';
import { FileUploadModule } from "angular-file-uploader";
import { DataTableModule } from 'angular2-datatable';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AnalyticsService } from './shared/services/analytics.service';
import { DeviceDetectorModule } from 'ngx-device-detector';
// import { AppModalContentComponent } from './home/home.component';
import {
    ApiService,
    AuthGuard,
    FooterComponent,
    HeaderComponent,
    JwtService,
    SharedModule,
    UserService,
    ReportService,
    SidebarComponent,
    BottomComponent,
    ApplicationService
    
} from './shared';


@NgModule({
    declarations: [
        AppComponent,
        FooterComponent,
        HeaderComponent,
        SidebarComponent,
        BottomComponent,
        // AppModalContentComponent
             
    ],
//   entryComponents: [AppModalContentComponent],
    exports: [],

    imports: [
        BrowserModule,
        SharedModule,
        NgbModule.forRoot(),
        DeviceDetectorModule.forRoot(),
        DataTableModule,
        HttpClientModule,
        AppRoutingModule,
        HomeModule,
        FileUploadModule
        
    ],
    providers: [
        ApiService,
        AuthGuard,
        JwtService,
        UserService,
        ReportService,
        ApplicationService,
        AnalyticsService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/rohini_india/angular/Srilanka-eta.org.lk/src/app/app.module.ts